module.exports = __webpack_public_path__ + "img/outline-check.41827ac7.svg";